export interface LoadingState extends Record<string, boolean> {}

export const initialLoadingState: LoadingState = {};
